var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "h3",
    { staticStyle: { "text-align": "center", "padding-top": "30%" } },
    [_vm._v("404页面不存在")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }